import type { ComponentType } from 'react';
import { HomeIcon, VideoIcon, MessageSquareIcon, FileIcon, UsersIcon } from './Icons';

type NavIcon = ComponentType<{ size?: number; color?: string }>;
export type NavItem = { href: string; label: string; Icon: NavIcon };

// Meetings menggabungkan daftar rapat + terjadwal + buat jadwal (Schedule dilebur).
// "More" tak lagi di nav — diakses lewat "Profil & pengaturan" di dropdown profil.
export const PRIMARY_NAV: NavItem[] = [
  { href: '/home', label: 'Home', Icon: HomeIcon },
  { href: '/meetings', label: 'Meetings', Icon: VideoIcon },
  { href: '/groups', label: 'Grup', Icon: UsersIcon },
  { href: '/chat', label: 'Chat', Icon: MessageSquareIcon },
  { href: '/recordings', label: 'Recordings', Icon: FileIcon },
];

// Bottom tab-bar mobile (4 item utama).
export const MOBILE_NAV: NavItem[] = [
  { href: '/home', label: 'Home', Icon: HomeIcon },
  { href: '/meetings', label: 'Meet', Icon: VideoIcon },
  { href: '/groups', label: 'Grup', Icon: UsersIcon },
  { href: '/chat', label: 'Chat', Icon: MessageSquareIcon },
  { href: '/recordings', label: 'Rekaman', Icon: FileIcon },
];

// Rute yang "dimiliki" sebuah item nav meski beda prefix.
// Schedule dilebur ke Meetings → semua /schedules/* menyalakan tab Meetings.
const NAV_ALIASES: Record<string, string[]> = {
  '/meetings': ['/schedules'],
};

export function isNavActive(pathname: string | null, href: string): boolean {
  if (!pathname) return false;
  const prefixes = [href, ...(NAV_ALIASES[href] ?? [])];
  return prefixes.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Nav khusus admin. Sengaja TERPISAH dari PRIMARY_NAV agar tidak satu baris pun
// dari nav yang sudah ada tersentuh. Konsumen menggabungkannya hanya untuk admin.
export const ADMIN_NAV: NavItem[] = [
  { href: '/devices', label: 'Alat VMS', Icon: VideoIcon },
];
